module.exports = __webpack_public_path__ + "static/media/logo.46568b74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 186
// module chunks = 0